/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./digitalTwinDetails.vue?vue&type=template&id=4cdde484&scoped=true"
import script from "./digitalTwinDetails.vue?vue&type=script&lang=js"
export * from "./digitalTwinDetails.vue?vue&type=script&lang=js"
import style0 from "./digitalTwinDetails.vue?vue&type=style&index=0&id=4cdde484&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cdde484",
  null
  
)

export default component.exports